// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --primary-navy: #1e3a8a;
  --primary-light-blue: #1e40af;
  --secondary-blue: #4b6dde;
  --text-primary: #030303;
  --text-secondary: #5e5e5e;
  --sidebar-bg: #cfcfd4;
  --sidebar-active-bg: #ffffff;
  --sidebar-active-text: #030303;
  --body-bg: #f8f9fa;
  --danger: #dc2626;
  --success: #10b981;
  --warning: #f59e0b;
  --focus-ring: #1e3a8a;
  --focus-ring-shadow: 0 0 0 3px rgba(30, 58, 138, 0.12);
  --gradient-navy: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%);
  --gradient-navy-hover: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%);
  --gradient-primary-btn: linear-gradient(135deg, #1e3a8a, #3b82f6);
  --gradient-primary-btn-hover: linear-gradient(135deg, #1e40af, #2563eb);
  --shadow-l1: 0 1px 3px rgba(0, 0, 0, 0.08);
  --shadow-l2: 0 4px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
  --shadow-l3: 0 8px 24px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.04);
  --shadow-l4: 0 16px 32px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.06);
  --shadow-l5: 0 24px 48px rgba(0, 0, 0, 0.12), 0 6px 12px rgba(0, 0, 0, 0.06);
  --display-xl: 48px;
  --display-lg: 36px;
  --heading-xl: 28px;
  --heading-lg: 22px;
  --heading-md: 18px;
  --heading-sm: 16px;
  --body-lg: 16px;
  --body-md: 14px;
  --body-sm: 13px;
  --caption: 12px;
  --micro: 11px;
  --weight-light: 300;
  --weight-regular: 400;
  --weight-medium: 500;
  --weight-semibold: 600;
  --weight-bold: 700;
  --space-xxs: 4px;
  --space-xs: 8px;
  --space-sm: 12px;
  --space-md: 16px;
  --space-lg: 24px;
  --space-xl: 32px;
  --space-2xl: 48px;
  --space-3xl: 64px;
  --space-4xl: 80px;
  --space-5xl: 96px;
  --radius-xs: 4px;
  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --radius-xl: 16px;
  --radius-pill: 9999px;
  --filter-panel-bg: #ffffff;
  --filter-panel-border-color: #e3e8ee;
  --filter-panel-radius: 8px; /* radius-md — shares the control corners */
  --filter-panel-padding: 16px; /* space-md */
  --filter-panel-gap: 12px; /* space-sm */
  --filter-panel-shadow: 0 1px 3px rgba(0, 0, 0, 0.08); /* Level 1 */
  --control-border-color: #d1d5db;
  --control-radius: 8px;
  --control-padding: 10px 12px;
  --control-font-size: 14px;
  --control-label-color: #374151;
  --control-value-color: #1e293b;
  --bp-mobile: 640px;
  --bp-tablet: 1023px;
  --bp-desktop: 1279px;
}

html {
  scroll-behavior: smooth;
}

[dir=rtl] {
  font-family: "Cairo", "Tajawal", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif;
  direction: rtl;
  text-align: right;
}

html[dir=rtl] body {
  font-family: "Poppins", "Cairo", "Tajawal", "Segoe UI", "Roboto", sans-serif;
}

[dir=ltr] {
  direction: ltr;
  text-align: left;
}

* {
  direction: inherit;
}

input,
textarea,
select {
  direction: inherit;
  text-align: inherit;
}

table {
  direction: inherit;
}

th,
td {
  text-align: inherit;
}

[dir=ltr] ul,
[dir=ltr] ol {
  padding-left: 1.5rem;
}
[dir=rtl] ul,
[dir=rtl] ol {
  padding-right: 1.5rem;
}

.modal-header,
.modal-footer {
  direction: inherit;
}

[dir=ltr] .sidebar {
  border-right: 1px solid #dee2e6;
}
[dir=rtl] .sidebar {
  border-left: 1px solid #dee2e6;
}

.header {
  direction: inherit;
}

nav,
.navbar {
  direction: inherit;
}

.card {
  direction: inherit;
}

[dir=rtl] .ant-form-item-required::after,
[dir=rtl] .ant-form-item-label > label.ant-form-item-required::after {
  position: relative !important;
  right: auto !important;
  left: -4px !important;
  margin-right: 4px !important;
  margin-left: 0 !important;
}

[dir=ltr] .ant-form-item-required::after,
[dir=ltr] .ant-form-item-label > label.ant-form-item-required::after {
  position: relative !important;
  left: auto !important;
  right: -4px !important;
  margin-left: 4px !important;
  margin-right: 0 !important;
}

.breadcrumb {
  --bs-breadcrumb-divider: "›";
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 0.75rem 1rem !important;
  margin-bottom: 1rem !important;
  list-style: none !important;
  background-color: #e9ecef !important;
  border-radius: 0.25rem !important;
}

.breadcrumb-item + .breadcrumb-item::before {
  content: var(--bs-breadcrumb-divider) !important;
  padding-inline-start: 0.5rem !important;
  padding-inline-end: 0.5rem !important;
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
  float: none !important;
}

body[dir=rtl] .breadcrumb,
html[dir=rtl] body .breadcrumb,
[dir=rtl] .breadcrumb {
  --bs-breadcrumb-divider: "›" !important;
  direction: rtl !important;
  text-align: right !important;
}
body[dir=rtl] .breadcrumb .breadcrumb-item + .breadcrumb-item::before,
html[dir=rtl] body .breadcrumb .breadcrumb-item + .breadcrumb-item::before,
[dir=rtl] .breadcrumb .breadcrumb-item + .breadcrumb-item::before {
  content: "›" !important;
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
  margin-right: 0.5rem !important;
  margin-left: 0 !important;
}

body[dir=ltr] .breadcrumb,
html[dir=ltr] body .breadcrumb,
[dir=ltr] .breadcrumb {
  --bs-breadcrumb-divider: "›" !important;
  direction: ltr !important;
  text-align: left !important;
}
body[dir=ltr] .breadcrumb .breadcrumb-item + .breadcrumb-item::before,
html[dir=ltr] body .breadcrumb .breadcrumb-item + .breadcrumb-item::before,
[dir=ltr] .breadcrumb .breadcrumb-item + .breadcrumb-item::before {
  content: "›" !important;
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
  margin-right: 0 !important;
  margin-left: 0.5rem !important;
}

/* Phone numbers with plus signs in RTL mode:
   numbers are always LTR so the + sign stays on the left */
[dir=rtl] .phone-number,
[dir=rtl] [data-phone=true],
[dir=rtl] .customer-phone,
[dir=rtl] .ltr-phone-number {
  direction: ltr !important;
  text-align: left !important;
  unicode-bidi: embed !important;
  display: inline-block !important;
}

/* Utility class — attach to any displayed phone value */
.ltr-phone-number {
  direction: ltr !important;
  text-align: left !important;
  unicode-bidi: embed !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/_global-rtl.scss","webpack://./src/styles/design-tokens.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACgChB;EAEE,uBAAA;EACA,6BAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,4BAAA;EACA,8BAAA;EACA,kBAAA;EAEA,iBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,qBAAA;EACA,sDAAA;EAGA,kEAAA;EACA,wEAAA;EACA,iEAAA;EACA,uEAAA;EAGA,0CAAA;EACA,yEAAA;EACA,yEAAA;EACA,0EAAA;EACA,4EAAA;EAGA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EAGA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EAGA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EAGA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EAQA,0BAAA;EACA,oCAAA;EACA,0BAAA,EAAA,2CAAA;EACA,4BAAA,EAAA,aAAA;EACA,wBAAA,EAAA,aAAA;EACA,oDAAA,EAAA,YAAA;EAGA,+BAAA;EACA,qBAAA;EACA,4BAAA;EACA,yBAAA;EACA,8BAAA;EACA,8BAAA;EAGA,kBAAA;EACA,mBAAA;EACA,oBAAA;ADxDF;;AA/DA;EACE,uBAAA;AAkEF;;AA/DA;EACE,oGAAA;EACA,cAAA;EACA,iBAAA;AAkEF;;AA5DA;EACE,4EAAA;AA+DF;;AA5DA;EACE,cAAA;EACA,gBAAA;AA+DF;;AA3DA;EACE,kBAAA;AA8DF;;AA1DA;;;EAGE,kBAAA;EACA,mBAAA;AA6DF;;AAzDA;EACE,kBAAA;AA4DF;;AAzDA;;EAEE,mBAAA;AA4DF;;AAtDE;;EACE,oBAAA;AA0DJ;AAxDE;;EACE,qBAAA;AA2DJ;;AAtDA;;EAEE,kBAAA;AAyDF;;AApDE;EACE,+BAAA;AAuDJ;AArDE;EACE,8BAAA;AAuDJ;;AAlDA;EACE,kBAAA;AAqDF;;AAjDA;;EAEE,kBAAA;AAoDF;;AAhDA;EACE,kBAAA;AAmDF;;AA9CE;;EAEE,6BAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EACA,yBAAA;AAiDJ;;AA5CE;;EAEE,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,2BAAA;EACA,0BAAA;AA+CJ;;AAvCA;EACE,4BAAA;EACA,wBAAA;EACA,0BAAA;EACA,gCAAA;EACA,8BAAA;EACA,2BAAA;EACA,oCAAA;EACA,iCAAA;AA0CF;;AAtCA;EACE,gDAAA;EACA,uCAAA;EACA,qCAAA;EACA,gCAAA;EACA,+BAAA;EACA,sBAAA;AAyCF;;AArCA;;;EAGE,uCAAA;EACA,yBAAA;EACA,4BAAA;AAwCF;AAtCE;;;EACE,uBAAA;EACA,gCAAA;EACA,+BAAA;EACA,+BAAA;EACA,yBAAA;AA0CJ;;AArCA;;;EAGE,uCAAA;EACA,yBAAA;EACA,2BAAA;AAwCF;AAtCE;;;EACE,uBAAA;EACA,gCAAA;EACA,+BAAA;EACA,0BAAA;EACA,8BAAA;AA0CJ;;AAtCA;2DAAA;AAEA;;;;EAIE,yBAAA;EACA,2BAAA;EACA,8BAAA;EACA,gCAAA;AAyCF;;AAtCA,wDAAA;AACA;EACE,yBAAA;EACA,2BAAA;EACA,8BAAA;AAyCF","sourcesContent":["// Global RTL/LTR styles\n\n// CANONICAL TOKEN LAYER (DESIGN.md §6.1, decision resolved 2026-11-01, option (a)):\n// emit the design-token :root custom properties ONCE, globally. `index.css` is a\n// plain .css file and cannot `@use` SCSS, so the @use belongs here — this file is\n// the last hop of the global chain (src/index.js → src/index.css → _global-rtl.scss).\n// Must stay the first rule in the file (Sass requires @use before any other rule).\n@use 'design-tokens';\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n[dir=\"rtl\"] {\n  font-family: 'Cairo', 'Tajawal', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  direction: rtl;\n  text-align: right;\n}\n\n// Keep Latin in Poppins but give Arabic glyphs a designed Arabic typeface\n// (body inherits Poppins from the global stack and would otherwise override\n// the [dir=\"rtl\"] html rule, silently falling back to an OS font for Arabic).\nhtml[dir=\"rtl\"] body {\n  font-family: 'Poppins', 'Cairo', 'Tajawal', 'Segoe UI', 'Roboto', sans-serif;\n}\n\n[dir=\"ltr\"] {\n  direction: ltr;\n  text-align: left;\n}\n\n// All components should inherit direction\n* {\n  direction: inherit;\n}\n\n// Form elements\ninput,\ntextarea,\nselect {\n  direction: inherit;\n  text-align: inherit;\n}\n\n// Tables\ntable {\n  direction: inherit;\n}\n\nth,\ntd {\n  text-align: inherit;\n}\n\n// Lists\nul,\nol {\n  [dir=\"ltr\"] & {\n    padding-left: 1.5rem;\n  }\n  [dir=\"rtl\"] & {\n    padding-right: 1.5rem;\n  }\n}\n\n// Modals\n.modal-header,\n.modal-footer {\n  direction: inherit;\n}\n\n// Sidebar\n.sidebar {\n  [dir=\"ltr\"] & {\n    border-right: 1px solid #dee2e6;\n  }\n  [dir=\"rtl\"] & {\n    border-left: 1px solid #dee2e6;\n  }\n}\n\n// Header\n.header {\n  direction: inherit;\n}\n\n// Navigation\nnav,\n.navbar {\n  direction: inherit;\n}\n\n// Cards\n.card {\n  direction: inherit;\n}\n\n// Ant Design Form Required Field Asterisk - Directional Positioning\n[dir=\"rtl\"] {\n  .ant-form-item-required::after,\n  .ant-form-item-label > label.ant-form-item-required::after {\n    position: relative !important;\n    right: auto !important;\n    left: -4px !important;\n    margin-right: 4px !important;\n    margin-left: 0 !important;\n  }\n}\n\n[dir=\"ltr\"] {\n  .ant-form-item-required::after,\n  .ant-form-item-label > label.ant-form-item-required::after {\n    position: relative !important;\n    left: auto !important;\n    right: -4px !important;\n    margin-left: 4px !important;\n    margin-right: 0 !important;\n  }\n}\n\n// Breadcrumb RTL Support - Comprehensive Fix\n// Override Bootstrap breadcrumb styles for proper LTR/RTL support\n\n// Base breadcrumb styles\n.breadcrumb {\n  --bs-breadcrumb-divider: '›';\n  display: flex !important;\n  flex-wrap: wrap !important;\n  padding: 0.75rem 1rem !important;\n  margin-bottom: 1rem !important;\n  list-style: none !important;\n  background-color: #e9ecef !important;\n  border-radius: 0.25rem !important;\n}\n\n// Breadcrumb item separator\n.breadcrumb-item + .breadcrumb-item::before {\n  content: var(--bs-breadcrumb-divider) !important;\n  padding-inline-start: 0.5rem !important;\n  padding-inline-end: 0.5rem !important;\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n  float: none !important;\n}\n\n// RTL breadcrumb styles\nbody[dir=\"rtl\"] .breadcrumb,\nhtml[dir=\"rtl\"] body .breadcrumb,\n[dir=\"rtl\"] .breadcrumb {\n  --bs-breadcrumb-divider: '›' !important;\n  direction: rtl !important;\n  text-align: right !important;\n\n  .breadcrumb-item + .breadcrumb-item::before {\n    content: '›' !important;\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n    margin-right: 0.5rem !important;\n    margin-left: 0 !important;\n  }\n}\n\n// LTR breadcrumb styles\nbody[dir=\"ltr\"] .breadcrumb,\nhtml[dir=\"ltr\"] body .breadcrumb,\n[dir=\"ltr\"] .breadcrumb {\n  --bs-breadcrumb-divider: '›' !important;\n  direction: ltr !important;\n  text-align: left !important;\n\n  .breadcrumb-item + .breadcrumb-item::before {\n    content: '›' !important;\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n    margin-right: 0 !important;\n    margin-left: 0.5rem !important;\n  }\n}\n\n/* Phone numbers with plus signs in RTL mode:\n   numbers are always LTR so the + sign stays on the left */\n[dir=\"rtl\"] .phone-number,\n[dir=\"rtl\"] [data-phone=\"true\"],\n[dir=\"rtl\"] .customer-phone,\n[dir=\"rtl\"] .ltr-phone-number {\n  direction: ltr !important;\n  text-align: left !important;\n  unicode-bidi: embed !important;\n  display: inline-block !important;\n}\n\n/* Utility class — attach to any displayed phone value */\n.ltr-phone-number {\n  direction: ltr !important;\n  text-align: left !important;\n  unicode-bidi: embed !important;\n}","// ============================================================\n// DESIGN TOKENS — Cashier Portal DESIGN.md Refactor\n// Navy Palette v1.0\n// ============================================================\n\n// ─── Colors ──────────────────────────────────────────────────\n$primary-navy: #1e3a8a;\n$primary-light-blue: #1e40af;\n$secondary-blue: #4b6dde;\n$text-primary: #030303;\n$text-secondary: #5e5e5e;\n$sidebar-bg: #cfcfd4;\n$sidebar-active-bg: #ffffff;\n$sidebar-active-text: #030303;\n$body-bg: #f8f9fa;\n\n// ─── Semantic colours (DESIGN.md §2.1 brand palette — CANONICAL) ──────────\n// These were Bootstrap-legacy ($danger #dc3545, $success #28a745,\n// $warning #ffc107), which contradicted §2.1 and produced the red/green/amber\n// drift the audit found on 14 pages. Frozen 2026-11-04 (WP0 / 11.1).\n// `$info` has no §2.1 role and is left as-is; §5.19 maps toast `info` to\n// `$secondary-blue` directly, so nothing consumes `$info` for brand work.\n$danger: #dc2626;\n$success: #10b981;\n$warning: #f59e0b;\n$info: #17a2b8;\n\n// ─── Focus ring (DESIGN.md §2.3 / §5.6 / §9.2 — ONE ring everywhere) ─────\n// `#1e40af` is HOVER / ACTIVE-ACCENT ONLY and must never be a focus ring.\n$focus-ring: #1e3a8a;\n$focus-ring-shadow: 0 0 0 3px rgba(30, 58, 138, 0.12);\n\n:root {\n  // ─── Navy Palette ─────────────────────────────────────────\n  --primary-navy: #1e3a8a;\n  --primary-light-blue: #1e40af;\n  --secondary-blue: #4b6dde;\n  --text-primary: #030303;\n  --text-secondary: #5e5e5e;\n  --sidebar-bg: #cfcfd4;\n  --sidebar-active-bg: #ffffff;\n  --sidebar-active-text: #030303;\n  --body-bg: #f8f9fa;\n  // §2.1 brand palette — was #dc3545 / #28a745 (Bootstrap legacy).\n  --danger: #dc2626;\n  --success: #10b981;\n  --warning: #f59e0b;\n  // §2.3 single focus ring.\n  --focus-ring: #1e3a8a;\n  --focus-ring-shadow: 0 0 0 3px rgba(30, 58, 138, 0.12);\n\n  // ─── Navy Gradients ───────────────────────────────────────\n  --gradient-navy: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%);\n  --gradient-navy-hover: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%);\n  --gradient-primary-btn: linear-gradient(135deg, #1e3a8a, #3b82f6);\n  --gradient-primary-btn-hover: linear-gradient(135deg, #1e40af, #2563eb);\n\n  // ─── Stacked Shadows ─────────────────────────────────────\n  --shadow-l1: 0 1px 3px rgba(0, 0, 0, 0.08);\n  --shadow-l2: 0 4px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);\n  --shadow-l3: 0 8px 24px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.04);\n  --shadow-l4: 0 16px 32px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.06);\n  --shadow-l5: 0 24px 48px rgba(0, 0, 0, 0.12), 0 6px 12px rgba(0, 0, 0, 0.06);\n\n  // ─── Type Scale ──────────────────────────────────────────\n  --display-xl: 48px;\n  --display-lg: 36px;\n  --heading-xl: 28px;\n  --heading-lg: 22px;\n  --heading-md: 18px;\n  --heading-sm: 16px;\n  --body-lg: 16px;\n  --body-md: 14px;\n  --body-sm: 13px;\n  --caption: 12px;\n  --micro: 11px;\n\n  // ─── Font Weights ────────────────────────────────────────\n  --weight-light: 300;\n  --weight-regular: 400;\n  --weight-medium: 500;\n  --weight-semibold: 600;\n  --weight-bold: 700;\n\n  // ─── Spacing ─────────────────────────────────────────────\n  --space-xxs: 4px;\n  --space-xs: 8px;\n  --space-sm: 12px;\n  --space-md: 16px;\n  --space-lg: 24px;\n  --space-xl: 32px;\n  --space-2xl: 48px;\n  --space-3xl: 64px;\n  --space-4xl: 80px;\n  --space-5xl: 96px;\n\n  // ─── Border Radius ───────────────────────────────────────\n  --radius-xs: 4px;\n  --radius-sm: 6px;\n  --radius-md: 8px;\n  --radius-lg: 12px;\n  --radius-xl: 16px;\n  --radius-pill: 9999px;\n\n  // ─── Filter panel chrome (WP0 / 11.2 — ONE shared shell) ──\n  // The filter panels (Campaigns, Products, Brands, Rewards library, Seller\n  // list, Points transactions) were five copy-pasted shells that had drifted to\n  // radius 10/12, 2px borders and up to seven `!important`s. These are the ONE\n  // set of values; a panel must not re-declare them. Sourced from DESIGN.md\n  // §5.2 (card hairline / Level 1 shadow) and §5.3 (control box).\n  --filter-panel-bg: #ffffff;\n  --filter-panel-border-color: #e3e8ee;\n  --filter-panel-radius: 8px;        /* radius-md — shares the control corners */\n  --filter-panel-padding: 16px;      /* space-md */\n  --filter-panel-gap: 12px;          /* space-sm */\n  --filter-panel-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);  /* Level 1 */\n\n  // Control box inside a filter panel (DESIGN.md §5.3, frozen).\n  --control-border-color: #d1d5db;\n  --control-radius: 8px;\n  --control-padding: 10px 12px;\n  --control-font-size: 14px;\n  --control-label-color: #374151;\n  --control-value-color: #1e293b;\n\n  // ─── Breakpoints ────────────────────────────────────────\n  --bp-mobile: 640px;\n  --bp-tablet: 1023px;\n  --bp-desktop: 1279px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
